<template>
    <div>
        <TextBanner>
            Das <b>Weltraumteleskop Hubble</b> liefert seit mehr als 30 Jahren Bilder aus den Tiefen des Alls. Das
            spektakulärste Bild finden Sie hinter dem orangen Punkt. <b>Nun soll das Webb-Teleskop als Nachfolger Hubble
            noch übertrumpfen.</b>
        </TextBanner>

        <InfoBox modalName="Hubble">
            <template #title>Das Tiefenfeld-Bild</template>
            <!--            <template #subline>Subline in Roman</template>-->
            <template>
                <p>
                    1995 war das sogenannte Tiefenfeld-Bild des Hubble-Teleskops eine Sensation.
                </p>
                <FullscreenImage :src="require('../assets/img/HubbleDeepFieldFull.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="640" data-height="360"
                                 v-lazy="require('../assets/img/HubbleDeepFieldFull_640t.jpg')"
                                 alt="Das Tiefenfeld-Bild, aufgezeichnet von Hubble.">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; Esa</div>
                            <!--                            #3 Bilderunterschrift: Bild, lazyload, FullsreenImage-->
                        </figcaption>
                    </figure>
                </FullscreenImage>

                <p>
                <b>Fast 3.000 bislang unbekannte Galaxien</b>
                    waren darauf zu erkennen und lieferten <b>Erkenntnisse über unser Universum</b>. Forscher überall
                    auf dem Globus waren begeistert, wie in folgendem Ausschnitt aus einer Doku von 1998.
                </p>


                <!-- ZDFPlayer -->
                <figure>
                    <ZDFPlayer
                        data-jsb='{"config":"https://3d.zdf.de/james-webb-teleskop/video/3Dconfiguration.json", "content":"https://3d.zdf.de/james-webb-teleskop/video/urknallundsternenstaub.json"}'></ZDFPlayer>
                    <figcaption>
                        <div class="legal">Quelle: 3sat</div>
                        Ausschnitt: 3sat-Doku “Urknall und Sternenstaub“ (1998)
                    </figcaption>
                </figure>

            </template>
        </InfoBox>

        <!-- TODO: Fallback -->
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/01_Pt.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/01_Lt.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <!--<img class="o-fit o-fit--cover" src="../assets/img/fallback/TextBanner.jpg" alt="">-->
                <img class="o-fit o-fit--cover" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt="">
                <div class="hotspot" v-on:click="infobox('Hubble')"></div>
            </picture>
        </Fallback>
    </div>
</template>

<script>
export default {
    name: 'UnpackStart',
    babylonState: {
        camera: {
            position: [-1.6, 1.5, 40],
            radiusLimits: [12, 100],
            useAutoRotationBehavior: true,
            idleRotationSpeed: 0.005,
            target: [0, -27, -100],
        },
        jwst: {
            position: [0, 0, 0],
            mdl_Hubble: {
                visible: true,
                position: [0, -27, 100],
                mdl_Label_Hubble: {
                    visible: true,
                    rotation: [0, 0, 0],
                    position: [5, -1, 0],
                    scale: 1
                },
                scale: 1
            },
            mdl_body: {
                // rotation:[0,-1,0],
                scale: 1,
                mdl_Label_jwst: {
                    visible: true,
                    rotation: [0, Math.PI * 1.2, 0],
                    position: [0, -4, 0],
                    scale: 2.5
                }
            },
        },
        hotspots: {
            info: {
                visible: true,
                infoBox: 'Hubble',
                position: [2.8, -27.7, -102],
                scale: 3,
            }
        },
    },
    babylonReady: function () {
        this.$babylonController.setAnimationsToFinal();
    }

}
</script>

<style lang="scss">

//.help-text--audio,
//.btn--audio{
//    visibility: hidden;
//}

</style>
